import { classSet } from '@umu/umu-dom';
import './index.scss';
import React, { useCallback, useRef } from 'react';

interface IProps {
    show: boolean;
    children: JSX.Element | JSX.Element[];
    className?: string;
    duration?: number;
    intrinsicSize?: string;
}

export const TransitionShow = (props: IProps) => {
    const { show, className = '', intrinsicSize = '6rem', duration = 0.4 } = props;
    const contentHeight = useRef(0);
    const shown = useRef(false);
    const wrapRef = useRef<HTMLDivElement | null>(null);
    const contentRef = useCallback(
        (node: HTMLDivElement | null) => {
            if (node && node.offsetHeight) {
                contentHeight.current = node.offsetHeight;
                wrapRef.current = node.parentElement as HTMLDivElement;
                show && (shown.current = true);
            }
        },
        [show],
    );

    const shrink = ` @keyframes shrink {
        0% { max-height: ${intrinsicSize}; }
        100% { max-height: 0; }
    }`;
    const stretch = `@keyframes stretch {
        0% { max-height: 0; }
        99% { max-height: ${intrinsicSize}; }
        100% { max-height: initial; overflow: visible; }
    }`;
    const cssDuration = `.transition-show-wrap.fold, .transition-show-wrap.unfold {animation-duration: ${duration}s}`;

    const cls = classSet({
        [className]: true,
        'transition-show-wrap': true,
        'fold': !show,
        'unfold': show,
        'shown': shown.current,
    });

    return (
        <div className={cls}>
            <style>
                {shrink}
                {stretch}
                {cssDuration}
            </style>
            <div ref={contentRef}>{props.children}</div>
        </div>
    );
};
